import * as z from "zod";

const StoreProductItemSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  variant: z.string(),
  price: z.string(),
  sku: z.string().optional(),
  imageUrl: z.string().optional(),
  tags: z.array(z.string()).optional(),
  productType: z.string().optional(),
  collections: z.array(z.string()).optional(),
});
export const StoreProductItemSchema: z.ZodType<StoreProductItem> =
  StoreProductItemSchema_;
export interface StoreProductItem extends z.infer<
  typeof StoreProductItemSchema_
> {}

export const getStoreProducts = {
  name: "getStoreProducts" as const,
  input: z.object({
    limit: z.number().int().min(1).max(100).optional(),
    query: z.string().max(200).optional(),
    skus: z.array(z.string().min(1).max(255)).max(100).optional(),
  }),
  output: z.object({
    items: z.array(StoreProductItemSchema),
    hasMore: z.boolean().default(false),
  }),
};
